import ProductModel from 'coreClasses/product/ProductModel';
import {IEventProductData} from 'coreClasses/events/IEvents';
import {IBasketProductLineItem} from 'coreInterfaces/common/IBasket';

import ManagerRepository from 'brandClasses/ManagerRepository';

import ECommerceProductModel from './EcommerceProductModel';

/**
 * Represents ECommerceProductDetailsModel
 */
export default class ECommerceProductDetailsModel extends ECommerceProductModel {
	/**
	 * @constructor
	 * @param {IEventProductData} productData - product data
	 */
	constructor(
		managerRepository: ManagerRepository,
		productData: IEventProductData,
		productItem?: IBasketProductLineItem
	) {
		super(productData, productItem);

		const product: ProductModel = productData.product;

		if (product?.isReady() && 'attributes' in productData) {
			for (let attribute in productData.attributes) {
				this[attribute] = productData.attributes[attribute];
			}
		}

		if (!product.isVariationGroup()) {
			const variationGroup = managerRepository.getProductsMgr().getProduct(
				product?.getVariationGroupId(),
			) as ProductModel;

			if (variationGroup) {
				this.category = variationGroup.getPrimaryCategoryId();
			}
		}
	}
};
